import React, { useState } from 'react'
import { Modal, Backdrop, Fade } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyle = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    width: '95%',
    height: '95%',
    overflow: 'hidden',
    outline: 'none',
    borderRadius: '2px'
  }
})

type Props = {
  open: boolean
  onClose: () => void
}

const ImageModal: React.FC<Props> = React.memo((props) => {
  const classes = useStyle()

  return (
    <Modal
      className={classes.modal}
      open={props.open}
      onClose={props.onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      onClick={props.onClose}
    >
      <Fade in={props.open}>
        <div className={classes.paper}>{props.children}</div>
      </Fade>
    </Modal>
  )
})
ImageModal.displayName = 'ImageModal'

export default ImageModal

export const useImageModal = () => {
  const [image, setImage] = useState<string>('')
  const [open, setOpen] = useState<boolean>(false)
  const onClose = () => setOpen(false)
  const handleOpen = (image: string) => {
    setImage(image)
    setOpen(true)
  }

  return {
    props: { open, onClose },
    others: { image, setImage, setOpen, handleOpen }
  }
}
